import React, { useState } from 'react';
import styled from 'styled-components';
import { BlankSpace } from '../genericComponents/layouts';
import { Text5M } from '../genericComponents/texts';

interface Props {
  title: string,
  children?: React.ReactNode,
  startsOpen?:boolean,
  newSection?: boolean,
}

export default function SectionCard({
  title, children, startsOpen = false, newSection,
}: Readonly<Props>) {
  const [isOpen, setisOpen] = useState(startsOpen);

  return (
    <Container>
      <SpacerContainer onClick={() => setisOpen(!isOpen)}>
        <Text5M>{title}</Text5M>
        <BlankSpace width="32px" />
        {
          newSection === true ? (<ButtonNewSection>Nueva sección</ButtonNewSection>) : ''
        }
      </SpacerContainer>
      <Collapsable>
        {children}
      </Collapsable>
    </Container>
  );
}

const Container = styled.section`
  width: 95%;
  max-width: 1000px;
  margin: 20px auto 28px auto;
  .opened{
    transition: max-height 0.5s ease-in;
    max-height: auto;
  }
  .closed{
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.20s ease-out;
    padding: 0;
  }

  @media (max-width: 700px){
    width: 100%;
  }
`;
const Collapsable = styled.div`
  border-radius: 16px;
  border: 1px solid #B3C9EE;
  padding-Top: 10px;
  padding: 0 15px;
  @media (max-width: 700px){
    padding: 0px;
  }
  
`;
const ButtonNewSection = styled.button`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #F5650B;
  color: #fff;
  font-size: 10px;
`;
export const SpacerContainer = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;
